import ErrorPage from './error-page-404';
import { LandingPage } from '@pages/landing';

const publicRoutes = [
  {
    path: '/',
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/landing',
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
];

export default publicRoutes;
